module.exports = __webpack_public_path__ + "img/em-pros-05.e3878bac.png";